'use client';

import React__default from 'react';
import { WarpBody } from '../../index.css.js';
import { useResumeModal } from '../../context/useResumeModal.js';
import { ETab } from '../../type.js';
import CircleChecked from '../../../Images/CircleChecked/index.js';

var Tabs = function (_a) {
    var contactInfo = _a.contactInfo, _b = _a.hiddenStep, hiddenStep = _b === void 0 ? 0 : _b;
    var _c = useResumeModal(), step = _c.step, uploadFile = _c.uploadFile, t = _c.t;
    return (React__default.createElement(WarpBody.HeaderTab, { hiddenStep: hiddenStep },
        hiddenStep > 0
            ? null
            : React__default.createElement(WarpBody.Tab, { actived: step === ETab.UPLOAD_CV, tabStatus: step > ETab.UPLOAD_CV && !!uploadFile },
                step > ETab.UPLOAD_CV && !!uploadFile ? React__default.createElement(CircleChecked, null) : React__default.createElement("span", null, ETab.UPLOAD_CV - hiddenStep),
                React__default.createElement("p", null, t('Tải Hồ Sơ'))),
        hiddenStep > 1
            ? null
            : React__default.createElement(WarpBody.Tab, { actived: step === ETab.CONTACT_INFORMATION, tabStatus: step > ETab.CONTACT_INFORMATION && (contactInfo === null || contactInfo === void 0 ? void 0 : contactInfo.address) !== '' },
                step > ETab.CONTACT_INFORMATION && (contactInfo === null || contactInfo === void 0 ? void 0 : contactInfo.address) !== '' ? (React__default.createElement(CircleChecked, null)) : (React__default.createElement("span", null, ETab.CONTACT_INFORMATION - hiddenStep)),
                React__default.createElement("p", null, t('Thông tin liên hệ'))),
        hiddenStep > 2
            ? null
            : React__default.createElement(WarpBody.Tab, { actived: step === ETab.WORKING_PREFERENCE, tabStatus: step > ETab.WORKING_PREFERENCE },
                step > ETab.WORKING_PREFERENCE ? React__default.createElement(CircleChecked, null) : React__default.createElement("span", null, ETab.WORKING_PREFERENCE - hiddenStep),
                React__default.createElement("p", null, t('Hoàn Chỉnh Hồ Sơ')))));
};

export { Tabs, Tabs as default };
//# sourceMappingURL=Tabs.js.map
